import { Injectable } from '@angular/core';
import * as fromRoot from '@app/store/reducers';
import { CognitoUser } from '@cco/model';
import { selectCurrentUser, selectCurrentUserPrivileges } from '@core/auth2/store/auth2.reducer';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';

@Injectable()
export class AuthUtilService {
  currentUser$: Observable<CognitoUser>;
  currentUser: CognitoUser;
  userPrivileges$: Observable<string[]>;
  userPrivileges: string[];
  user$: Observable<CognitoUser>;
  // loggedIn$: Observable<boolean>;
  user: CognitoUser;

  constructor(private store: Store<fromRoot.State>) {
    this.currentUser$ = this.store.pipe(
      select(fromRoot.selectAuth2State),
      select(selectCurrentUser),
    );
    this.currentUser$.subscribe(currentUser => (this.currentUser = currentUser));
    this.userPrivileges$ = this.store.pipe(
      select(fromRoot.selectAuth2State),
      select(selectCurrentUserPrivileges),
    );
    this.userPrivileges$.subscribe(userPrivileges => (this.userPrivileges = userPrivileges));
    this.user$ = this.store.pipe(select(fromRoot.selectCurrentUser));
    // this.loggedIn$ = this.store.pipe(select(fromRoot.selectLoggedIn));
    this.user$.subscribe(u => (this.user = u));
  }

  /**
   * @returns true if the user has at least one of the privileges
   */
  userHasPrivilege(...privileges: string[]): boolean {
    if (!this.currentUser) {
      return false;
    }

    for (const p of privileges) {
      if (this.userPrivileges.includes(p)) {
        return true;
      }
    }

    return false;
  }
  /*
  userHasPrivilege(...privileges: string[]): boolean {
    if (!this.user) {
      return false;
    }

    for (const r of this.user.roles) {
      for (const p of r.privileges) {
        for (const lp of privileges) {
          if (lp === p.name) {
            return true;
          }
        }
      }
    }

    return false;
  }
  */

  /**
   * @returns Observable<boolean> that becomes true if the user has at least one of the privileges
   */
  obUserHasPrivilege(...privileges: string[]): Observable<boolean> {
    return this.userPrivileges$.pipe(
      skipWhile(userPrivileges => !userPrivileges),
      map((userPrivileges) => {
        for (const p of privileges) {
          if (userPrivileges.includes(p)) {
            return true;
          }
        }

        return false;
      }),
    );
  }
  /*
  obUserHasPrivilege(...privileges: string[]): Observable<boolean> {
    return this.user$.pipe(
      skipWhile(u => !u),
      map(u => {
        if (!u || !u.roles || !u.roles[0].privileges) {
          return false;
        }

        for (const r of u.roles) {
          for (const p of r.privileges) {
            for (const lp of privileges) {
              if (lp === p.name) {
                return true;
              }
            }
          }
        }

        return false;
      })
    );
  }
  */

  /**
   * @returns Observable<boolean> that becomes true if the user has at least one of the atLeastOne privileges and all of the all privileges
   */
  obUserHasPrivileges(atLeastOne: string | string[], all: string | string[]): Observable<boolean> {
    atLeastOne = !atLeastOne ? [] : typeof atLeastOne === 'string' ? [atLeastOne] : atLeastOne;
    all = !all ? [] : typeof all === 'string' ? [all] : all;

    return this.userPrivileges$.pipe(
      map((userPrivileges) => {
        if (!userPrivileges) {
          return false;
        }

        let hasAtLeastOne = !atLeastOne;
        let missingAny = false;

        for (const p of atLeastOne) {
          if (userPrivileges.includes(p)) {
            hasAtLeastOne = true;
          }
        }

        for (const p of all) {
          if (!userPrivileges.includes(p)) {
            missingAny = true;
          }
        }

        return hasAtLeastOne && !missingAny;
      }),
    );
  }
  /*
  obUserHasPrivileges(atLeastOne: string | string[], all: string | string[]): Observable<boolean> {
    atLeastOne = !atLeastOne ? [] : typeof atLeastOne === 'string' ? [atLeastOne] : atLeastOne;
    all = !all ? [] : typeof all === 'string' ? [all] : all;

    return this.user$.pipe(
      skipWhile(u => !u),
      map(u => {
        if (!u || !u.roles || !u.roles[0].privileges) {
          return false;
        }

        let hasAtLeastOne = !atLeastOne;
        let missingAny = false;

        for (const r of u.roles) {
          for (const p of r.privileges) {
            for (const lp of atLeastOne) {
              if (lp === p.name) {
                hasAtLeastOne = true;
              }
            }
          }

          for (const lp of all) {
            let missing = true;
            for (const p of r.privileges) {
              if (lp === p.name) {
                missing = false;
              }
            }

            if (missing === true) {
              missingAny = true;
            }
          }
        }

        return hasAtLeastOne && !missingAny;
      })
    );
  }
  */
}
